import script from "./CertificateTableRow.vue?vue&type=script&setup=true&lang=js"
export * from "./CertificateTableRow.vue?vue&type=script&setup=true&lang=js"

import "./CertificateTableRow.vue?vue&type=style&index=0&id=cd04493c&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd04493c"]])

export default __exports__